
import 'hamburgers/dist/hamburgers.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './eac2027.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import Home from './Home';

import InfoTopicsSpecialSessions from './pages/InfoTopicsSpecialSessions';
import InfoCommunityMeetings from './pages/InfoCommunityMeetings';

// import InfoPlenariesKeynotes from './pages/InfoPlenariesKeynotes';
import InfoTentativeProgram from './pages/InfoTentativeProgram';
// import InfoInstructionsPresenters from './pages/InfoInstructionsPresenters';
import InfoAwards from './pages/InfoAwards';
// import InfoWorkshops from './pages/InfoWorkshops';
// import InfoScientificExcursions from './pages/InfoScientificExcursions';
// import InfoYin from './pages/InfoYin';
import InfoCommittees from './pages/InfoCommittees';
import InfoContacts from './pages/InfoContacts';
// import InfoProceedings from './pages/InfoProceedings';

// import RegistrationAbstractSubmission from './pages/RegistrationAbstractSubmission';
// import RegistrationInfo from './pages/RegistrationInfo';

// import ProgramConftool from './pages/ProgramConftool';

import Sponsors from './pages/Sponsors';

import Location from './pages/Location';
import Venue from './pages/Venue';
import Accommodation from './pages/Accommodation';
import Travel from './pages/Travel';
import Visa from './pages/Visa';
import SocialEvents from './pages/SocialEvents';
import ScrollToTop from './components/ScrollToTop';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <Navigation />
      <Routes>
        <Route path="/" element={<Home />} />
        
        <Route path="/topics-and-special-sessions" element={<InfoTopicsSpecialSessions />} />
        <Route path="/community-meetings" element={<InfoCommunityMeetings />} />
        <Route path="/awards" element={<InfoAwards />} />
        <Route path="/committees" element={<InfoCommittees />} />
        <Route path="/contacts" element={<InfoContacts />} />
        <Route path="/tentative-program" element={<InfoTentativeProgram />} />

        {/*
        <Route path="/plenaries-and-keynotes" element={<InfoPlenariesKeynotes />} />
        
        <Route path="/instructions-for-presenters" element={<InfoInstructionsPresenters />} />
        
        <Route path="/workshops" element={<InfoWorkshops />} />
        <Route path="/scientific-excursions" element={<InfoScientificExcursions />} />
        <Route path="/yin" element={<InfoYin />} />
        
       
        <Route path="/proceedings" element={<InfoProceedings />} />
        */}

        {/*
        <Route path="/abstract-submission" element={<RegistrationAbstractSubmission />} />
        <Route path="/registration" element={<RegistrationInfo />} />
        */}

        {/* <Route path="/conftool" element={<ProgramConftool />} /> */}
        {/*  */}

        <Route path="/location" element={<Location />} />
        <Route path="/venue" element={<Venue />} />
        <Route path="/accommodation" element={<Accommodation />} />
        <Route path="/travel" element={<Travel />} />
        <Route path="/visa" element={<Visa />} />
        <Route path="/social-events" element={<SocialEvents />} />
        <Route path="/sponsors" element={<Sponsors />} />
      </Routes>

      <Footer />
    </Router>
  );
}

export default App;